import { FC, memo } from 'react'

import { pushDataLayer } from 'utils/push-data-layer'

import { AnchorButtonProps } from './anchor-button.model'
import { StyledAnchor } from './styles'


export const AnchorButton: FC<AnchorButtonProps> = memo(({ children, href, size = 'md', color = 'default', dataLayer, id, className }) => (
    <StyledAnchor
        id={id}
        className={className}
        href={href}
        $size={size}
        $color={color}
        {...(dataLayer && { onClick: () => pushDataLayer(dataLayer) })}
    >
        {children}
    </StyledAnchor>
))

AnchorButton.displayName = 'AnchorButton'